import { useState, type FC } from "react";
import ChatMessageListAssistantItem from "./ChatMessageListAssistantItem";
import RatingInput from "./RatingInput";

interface ChatMessageListFeedbackItemProps {
  messageId: number;
  threadId: number;
  message: string;
  options: string[];
  rating: number | null;
  isTyping: boolean;
  onFinished?: () => void;
  onSubmitRating: (rating: string) => void;
}

const ChatMessageListFeedbackItem: FC<ChatMessageListFeedbackItemProps> = ({ messageId, threadId, message, options, rating, isTyping, onFinished, onSubmitRating }) => {
  const [showRatingInput, setShowRatingInput] = useState(!isTyping && !rating);

  const handleFinished = (): void => {
    setShowRatingInput(!rating);
    onFinished?.();
  };

  const handleSubmitRating = (rating: string): void => {
    setShowRatingInput(false);
    onSubmitRating(rating);
  };

  return (
    <>
      <ChatMessageListAssistantItem
        messageId={messageId}
        threadId={threadId}
        message={message}
        sender={null}
        isTyping={isTyping}
        onFinished={handleFinished}
        reportRichMedia={false}
      >
        {showRatingInput && <RatingInput onSubmit={handleSubmitRating} options={options} />}
      </ChatMessageListAssistantItem>
    </>
  );
};

export default ChatMessageListFeedbackItem;
